
// Function to calculate the largest time unit remaining
export function getTimeLeftString(expiryTimestamp) {
    // Handle empty, null, or undefined values
    if (!expiryTimestamp || expiryTimestamp === '') {
        return '';
    }

    // Convert ISO string to timestamp
    const expiryDate = new Date(expiryTimestamp);
    const now = Date.now();
    const diff = Math.max(0, expiryDate.getTime() - now);

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);

    if (years > 0) return `${years} years left`;
    if (months > 0) return `${months} months left`;
    if (days > 0) return `${days} days left`;
    if (hours > 0) return `${hours % 24} hours left`;
    if (minutes > 0) return `${minutes % 60} min left`;
    return `${seconds % 60} sec left`;
}

export function sortTasks(list, type) {
    if (!list) return [];
    return list
        .map(item => ({
            ...item,
            creation_timestamp: item.creation_timestamp ? new Date(item.creation_timestamp) : new Date(0)
        }))
        .sort((a, b) => type === 'must_have'
            ? b.creation_timestamp - a.creation_timestamp
            : a.creation_timestamp - b.creation_timestamp)
        .sort((a, b) => a.order - b.order || Number(a.is_completed) - Number(b.is_completed));
}